// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./abhaTokenViewTableHeader.scss";
import { HEADERLIST } from "../../constant";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaTokenViewTableHeader = (props) => {
  // const declarations ⇒

  const { abhaTokenHeaderFilter, displayNormalFilterList, openMenuList } =
    props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  const getClassName = (hl) => {
    let name = "";
    if (hl.title === HEADERLIST.TOKENO) {
      name = "atvhw-title-token-filter";
    } else if (hl.title === HEADERLIST.PATIENTNAME) {
      name = "atvhw-title-name-status-filter";
    } else if (hl.title === HEADERLIST.STATUS) {
      name = "atvhw-status-filter";
    } else if (hl.title === HEADERLIST.PROFILESHAREDON) {
      name = "atvhw-title-profile-shared-filter";
    }
    return name;
  };

  // create UI ⇒

  const displayAbhaTokenContentHeader = () => {
    return (
      <>
        <div className="abha-token-view-table-header-wrapper">
          {abhaTokenHeaderFilter?.map((hl, ind) => (
            <div className={getClassName(hl)} key={ind}>
              <span>{hl.title}</span>
              <span style={{ marginLeft: "10px", position: "relative" }}>
                <img
                  src={hl.filter_icon}
                  alt=""
                  style={{ marginBottom: "3px", cursor: "pointer" }}
                  onClick={() => openMenuList(hl)}
                />

                {hl.show_filter && displayNormalFilterList(hl)}
              </span>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="abha-token-view-table-header-container">
      {displayAbhaTokenContentHeader()}
    </div>
  );
};

// export ⇒

export default AbhaTokenViewTableHeader;
